<template>
	<div class="companyOf">
		<div class="companyOf-top">
			<div class="companyOf-top-img">
				<img v-lazy="topImg" :key="topImg" alt="公司介绍" />
			</div>
			<div class="top-center">
				<p>捷途慧声科技有限公司</p>
				<span>国内深耕AI服务领域的解决方案提供商</span>
				<el-button
					class="banner-btn"
					plain
					@click="
						() => {
							this.$router.push('/formSub')
						}
					"
					>联系我们</el-button
				>
			</div>
		</div>

		<div class="content">
			<div class="navigation">
				<div
					class="iconNav-item"
					v-for="(i, index) in navList"
					:key="index"
					@click="handleNav(i.ref)"
				>
					<div class="iconNav-item-img">
						<img
							v-lazy="i.iconImg"
							:key="i.iconImg"
							alt="iconImg"
						/>
					</div>

					<p>{{ i.name }}</p>
				</div>
			</div>
			<div ref="aboutUsRef">
				<about-us />
			</div>
			<div ref="milestoneRef">
				<Milestone />
			</div>

			<div ref="honorRef">
				<Honor />
			</div>
			<div ref="addressRef">
				<Address />
			</div>
		</div>
	</div>
</template>

<script>
import AboutUs from './childCpn/AboutUs'
import Milestone from './childCpn/Milestone'
import Honor from './childCpn/Honor'
import Address from './Address/index'
export default {
	name: 'companyOf',
	data() {
		return {
			topImg: require('@/assets/img/company/banner.png'),
			navList: [
				{
					id: 0,
					iconImg: require('@/assets/img/company/nav/nav1.png'),
					name: '关于我们',
					ref: 'aboutUsRef',
				},
				{
					id: 1,
					iconImg: require('@/assets/img/company/nav/nav2.png'),
					name: '发展历程',
					ref: 'milestoneRef',
				},
				{
					id: 2,
					iconImg: require('@/assets/img/company/nav/nav3.png'),
					name: '企业荣誉',
					ref: 'honorRef',
				},
				{
					id: 3,
					iconImg: require('@/assets/img/company/nav/nav4.png'),
					name: '联系我们',
					ref: 'addressRef',
				},
			],
		}
	},
	created() {},
	mounted() {},
	watch: {},
	methods: {
		handleNav(ref) {
			this.$refs[ref].scrollIntoView(true)
		},
	},
	components: {
		AboutUs,
		Milestone,
		Honor,
		Address,
	},
	computed: {},
	destroyed() {},
}
</script>
<style lang="scss" scoped>
.companyOf {
	.companyOf-top {
		width: 100%;
		overflow: hidden;
		/* 1920→1440：高度固定 676px，宽度变窄时 cover 裁切 */
		height: 676px;
		position: relative;
		.companyOf-top-img {
			width: 100%;
			height: 100%;
			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
				object-position: center;
			}
		}
		.top-center {
			/* 与圣杯中间区对齐：总宽 - 两侧 gutter = 1280 */
			width: calc(100% - 2 * var(--page-gutter));
			min-width: 174px;
			max-width: 680px;
			height: 200px;
			position: absolute;
			left: var(--page-gutter);
			top: 0;
			bottom: 0;
			margin: auto;
			text-align: left;
			p {
				font-size: 56px;
				font-family: 'PingFang SC', 'Source Han Sans SC';
				font-weight: 700;
				line-height: 82px;
				color: #333333;
				margin-bottom: 10px;
			}
			span {
				display: block;
				font-size: 24px;
				font-family: 'PingFang SC', 'Source Han Sans SC';
				font-weight: 400;
				color: #333333;
				line-height: 36px;
				margin-bottom: 38px;
			}
			.banner-btn {
				width: 152px;
				height: 54px;
				background-color: transparent;
				color: #ffffff;
				font-size: 18px;
				font-family: 'PingFang SC', 'Source Han Sans SC';
				font-weight: 400;
				line-height: 24px;
				letter-spacing: 1px;
				border-radius: 30px;
				background: linear-gradient(
					138.1deg,
					rgba(27, 111, 255, 1) 0%,
					rgba(38, 168, 255, 1) 100%
				);
				&:hover {
					border: 1px solid transparent;
					background-color: #ececef;
				}
			}
		}
	}

	.content {
		position: relative;
	}
	.navigation {
		/* 与圣杯中间内容区对齐：左右 = gutter，中间恒为 1280 */
		width: calc(100% - 2 * var(--page-gutter));
		box-sizing: border-box;
		height: 164px;
		border-radius: 8px;
		background-color: #ffffff;
		box-shadow: 0 4px 10px 0px #d1ddeb;
		position: absolute;
		top: -60px;
		left: var(--page-gutter);
		display: flex;
		justify-content: space-around;
		align-items: center;
		z-index: 9;
		.iconNav-item {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			cursor: pointer;
			&-img {
				width: 60px;
				height: 60px;
				margin: 0 18px;
			}
			p {
				font-size: 24px;
				font-family: 'PingFang SC', 'Source Han Sans SC';
				font-weight: 700;
				color: #687181;
				line-height: 1;
				margin-top: 16px;
			}
		}
	}
}
@media screen and (max-width: 768px) {
	.companyOf {
		.companyOf-top {
			height: 178px;
			.top-center {
				height: 65px;
				width: calc(100% - 80px);
				left: 40px;
				p {
					font-size: 16px;
					font-weight: 700;
					color: #333333;
					line-height: 22px;
					margin-bottom: 1px;
				}
				span {
					font-size: 8px;
					color: #333333;
					line-height: 12px;
					margin-bottom: 0.45rem;
				}
				.banner-btn {
					width: 59px;
					height: 22px;
					font-size: 10px;
					color: #ffffff;
					line-height: 10px;
					padding: 0;
					border-width: 0.01vw;
					&::after {
						transform: scale(0.5);
					}
				}
			}
		}
		.navigation {
			width: calc(100% - 32px);
			height: 44px;
			top: -21px;
			.iconNav-item {
				&-img {
					width: 16px;
					height: 16px;
				}
				p {
					font-size: 6px;
					margin-top: 4px;
				}
			}
		}
	}
}
</style>
